module.exports = __webpack_public_path__ + "media/images/homes/Timeclock-2a190861cc1fab7ff279f916be13b81a.png";